module.exports = __webpack_public_path__ + "static/ThePopulation_2746x1000-a4c28523cfe1baa27e579d66cf9ca44b.png";